import React, { useState, ReactNode } from 'react';
import ConfirmationModal from '../components/common/ConfirmationModal';
import { ConfirmationContext, ConfirmationOptions } from './confirmationContext';

export const ConfirmationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<ConfirmationOptions>({
    title: '',
    message: '',
    onConfirm: () => {},
  });
  
  const showConfirmation = (confirmOptions: ConfirmationOptions) => {
    setOptions(confirmOptions);
    setIsOpen(true);
  };
  
  const handleClose = () => {
    setIsOpen(false);
    if (options.onCancel) {
      options.onCancel();
    }
  };
  
  return (
    <ConfirmationContext.Provider value={{ showConfirmation }}>
      {children}
      <ConfirmationModal
        isOpen={isOpen}
        onClose={handleClose}
        title={options.title}
        message={options.message}
        confirmText={options.confirmText}
        cancelText={options.cancelText}
        confirmVariant={options.confirmVariant}
        onConfirm={options.onConfirm}
      />
    </ConfirmationContext.Provider>
  );
}; 